import { render } from "./price_b.vue?vue&type=template&id=6222cbcc"
import script from "./price_b.vue?vue&type=script&lang=js"
export * from "./price_b.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__